export default __webpack_public_path__ + "static/media/evreux13.51c9b836.jpg";